import { Card } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Users, CalendarPlus, Video } from "lucide-react";
import api from "@/lib/api";

const when = (iso) => new Date(iso).toLocaleString([], {
  weekday: "long", month: "long", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short",
});

export function HuddleCard({ huddle }) {
  if (!huddle) return null;
  const addToCalendar = async () => {
    const { data } = await api.get("/huddle/ics", { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url; a.download = "student-huddle.ics"; a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <Card className="border-l-4 border-cc-blue bg-gradient-to-r from-cc-blue/5 to-transparent" data-testid="huddle-card">
      <div className="flex flex-wrap items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-cc-blue/10 flex items-center justify-center shrink-0">
          <Users className="w-5 h-5 text-cc-blue" />
        </div>
        <div className="flex-1 min-w-[16rem]">
          <p className="text-[10px] font-bold uppercase tracking-[0.08em] text-cc-blue">Monthly Student Huddle · {huddle.slot_label}</p>
          <p className="text-base font-semibold text-zinc-900 mt-1" data-testid="huddle-when">{when(huddle.start)}</p>
          <p className="text-sm text-zinc-600 mt-1.5">{huddle.topic}</p>
          <p className="text-xs text-zinc-400 mt-1">{huddle.duration_minutes} minutes with all three Campus Coordinators · shown in your local time</p>
        </div>
        <div className="flex flex-wrap gap-2 basis-full sm:basis-auto">
          {huddle.teams_url ? (
            <Button asChild className="bg-cc-blue hover:bg-cc-blue-dark text-white" data-testid="huddle-join-btn">
              <a href={huddle.teams_url} target="_blank" rel="noreferrer"><Video className="w-4 h-4 mr-1.5" />Join on Teams</a>
            </Button>
          ) : (
            <span className="text-xs text-amber-600 self-center" data-testid="huddle-no-link">Teams link coming from your coordinator</span>
          )}
          <Button variant="outline" onClick={addToCalendar} data-testid="huddle-ics-btn"><CalendarPlus className="w-4 h-4 mr-1.5" />Add to calendar</Button>
        </div>
      </div>
    </Card>
  );
}
